module.exports = __webpack_public_path__ + "img/2P.0f2ab272.png";